import PropTypes from 'prop-types';
import {Translate, Localize} from 'react-redux-i18n';

function DatetimeFormat(props) {
  if (props.value) {
    return <Localize
      value={props.value}
      dateFormat={`datetime.${props.format}`}
    />;
  }

  return <Translate value="datetime.undefined"/>;
}

DatetimeFormat.defaultProps = {
  value: null
};

DatetimeFormat.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  format: PropTypes.oneOf(['shortDate', 'shortDatetime']).isRequired
};

export default DatetimeFormat;
